<template>
  <div class="pagination-wrapper">
    <el-pagination
      class="is-print-hide common-el-pagination"
      layout="prev, pager, next, total, jumper, sizes"
      :total="total"
      :current-page="pageNo"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      @current-change="val => $emit('handle-pageNo', val)"
      @size-change="val => $emit('handle-pageSize', val)"
    />
    <div class="sureJump global_common_button_goast">确定</div>
  </div>
</template>

<script>
export default {
  name: 'pagination',
  props: {
    total: {
      type: Number
    },
    pageNo: {
      type: Number
    },
    pageSize: {
      type: Number
    },
    pageSizes: {
      type: Array
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 22px;

  /deep/.el-pagination {
    margin-top: 0;
  }

  .sureJump {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    width: 80px;
    height: 32px;
    border-radius: 3px;
    cursor: pointer;
  }
}
</style>
